var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star"},[_vm._l((5),function(i){return _c('font',{key:i,staticClass:"iconfont color_999",class:[_vm.sizeClass,i<=_vm.current?'cover':''],on:{"click":function($event){return _vm.handler(i)}}},[_vm._v("")])}),_vm._v(" "),_vm._t("scorewrap")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-073e9972","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugins/star.vue
// module id = 1239
// module chunks = 382